/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shift_Word_Back_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Shift Word Up" |
*
* @param {Shift_Word_Back_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shift_word_back_aria_label = /** @type {((inputs?: Shift_Word_Back_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shift_Word_Back_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decaler le Mot en Haut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wort nach oben verschieben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta parola su")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сдвиг слова вверх")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazar palabra hacia arriba")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向上移动单词")
	if (locale === "ja") return /** @type {LocalizedString} */ ("単語を上にシフト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शब्द को ऊपर ले जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Shift Word Up")
	return /** @type {LocalizedString} */ ("Shift Word Up")
});